// Action types for Templates CRUD operations
export const CREATE_TEMPLATE: string = 'CREATE_TEMPLATE';
export const CREATE_TEMPLATE_ASYNC: string = 'CREATE_TEMPLATE_ASYNC';

export const GET_TEMPLATES: string = 'GET_TEMPLATES';
export const GET_TEMPLATES_ASYNC: string = 'GET_TEMPLATES_ASYNC';

export const GET_TEMPLATE: string = 'GET_TEMPLATE';
export const GET_TEMPLATE_ASYNC: string = 'GET_TEMPLATE_ASYNC';

export const UPDATE_TEMPLATE: string = 'UPDATE_TEMPLATE';
export const UPDATE_TEMPLATE_ASYNC: string = 'UPDATE_TEMPLATE_ASYNC';

export const DELETE_TEMPLATE: string = 'DELETE_TEMPLATE';
export const DELETE_TEMPLATE_ASYNC: string = 'DELETE_TEMPLATE_ASYNC';

export const CLEAR_TEMPLATES_DATA: string = 'CLEAR_TEMPLATES_DATA';
